// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
var define;
var is_node = typeof module=='object' && module.exports;
if (is_node)
    define = require('../../../../util/require_node.js').define(module, '..');
else
    define = self.define;
define([], ()=>{
const E = {};
E.intro = [['div',
    [['h1',
        [`CSS/LESS Coding Convention`],
        {className: `title`},
    ],
    ['p',
        [['b',
            [`Improvements? Suggestions?`],
        ],
        ` email `,
        ['a',
            [`dna@hola.org`],
            {href: `mailto:dna@hola.org`},
        ],
        ` `],
    ]],
    {className: `head`},
]];
E.data = [
    {
        id: 'gen',
        title: `General CSS`,
        tag: 'h2',
        html: [],
    },
    {
        id: 'consistent_minimal',
        title: `Consistent and Minimal`,
        tag: 'h3',
        html: [['p',
            [` Most important rules:`,
            ['br'],
            ['a',
                [`Be consistent`],
                {href: `/dna/js_code#overview-consistent`},
            ],
            `.`,
            ['br'],
            ['a',
                [`Be minimal`],
                {href: `/dna/js_code#overview-minimal`},
            ],
            `.`,
            ['br'],
            ['a',
                [`Use tools`],
                {href: `/dna/js_code#overview-tool`},
            ],
            `.`,
            ['br'],
            ` Read these sections carefully. `],
        ]],
    },
    {
        id: 'react',
        title: `React`,
        tag: 'h2',
        html: [],
    },
    {
        id: 'react-scope',
        title: `Scope`,
        tag: 'h3',
        html: [['p',
            [`Write CSS per component.`],
        ],
        ['pre',
            [`let Btn = props=><a className="main_links" href={props.href}>
    {props.children}</a>;
let Contact_link = props=><a className="main_links" href={props.href}>
    {props.children}</a>;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`let Btn = props=><a className="btn" href={props.href}>{props.children}</a>;
let Contact_link = props=><Btn {...props}/>;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`.btn {
    color: @dark_blue;
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Keep the same syling wherever the component is used: don't nest
                component CSS inside a different component.`],
        ],
        ['pre',
            [`.main_page {
    .btn {
        color: @white;
    }
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`.main_page {
    color: @white;
}
.btn {
    color: @dark_blue;
    .btn-main {
        color: @white;
    }
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'react-flat',
        title: `Flat`,
        tag: 'h3',
        html: [['p',
            [` Make all component CSS global. A component should look the
                same in on any page in and inside any other component. `],
        ],
        ['pre',
            [`.main_page {
    .btn {
        color: @dark_blue;
    }
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`.btn {
    color: @dark_blue;
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [` Nest component sub-classes inside the component less to group
                the definitions together. `],
        ],
        ['pre',
            [`.btn {
    padding: 5px;
}
.btn-text {
    color: @dark_blue;
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`.btn {
    padding: 5px;
    .btn-text {
        color: @dark_blue;
    }
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [` Inside a component's class keep it flat - only one level of
                nesting. `],
        ],
        ['pre',
            [`.btn {
    padding: 5px;
    .btn-left {
        float: left;
        .btn-text {
            color: @dark_blue;
        }
    }
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`.btn {
    padding: 5px;
    .btn-left {
        float: left;

    }
    .btn-text {
        color: @dark_blue;
    }
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'react-naming',
        title: `Naming`,
        tag: 'h3',
        html: [['p',
            [`Use `,
            ['a',
                [`Unix notation`],
                {href: `/dna/tree_code#name-unix`},
            ],
            ` for naming`],
        ],
        ['pre',
            [`.startButton {
    color: @white;
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`.start-button {
    color: @white;
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`.start_button {
    color: @white;
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Use the same name as the react component`],
        ],
        ['pre',
            [`let Btn = props=><a className="button_round" href={props.href}>
    {props.children}</a>;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`let Btn = props=><a className="btn" href={props.href}>
    {props.children}</a>;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Use parent class name to prefix inner class names to pervent
                collisions.`],
        ],
        ['pre',
            [`.btn {
    .text {
          color: @white;
    }
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`.btn {
    .btn-text {
          color: @white;
    }
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Use dash "-" as a delimiter between prefixes.`],
        ],
        ['pre',
            [`.btn {
    .btn_text {
          color: @white;
    }
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`.btn {
    .btn-text {
          color: @white;
    }
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Use "sc_" as a prefix for sections.`],
        ],
        ['pre',
            [`let Many_ips = props=><Section className="many_ips">
    <h2>title</h2></Section>;
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`let Many_ips = props=><Section className="sc_many_ips">
    <h2>title</h2></Section>;
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [`Do not use "ad-" prefix for class names. Such items can be
                removed by ad blockers. Check that your code works with the
                ad blockers enabled.`],
        ],
        ['pre',
            [`.ad-text {
    color: @white;
}
`],
            {className: `cm-s-default code bad  has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['pre',
            [`.item-text {
    color: @white;
}
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'html',
        title: `HTML`,
        tag: 'h2',
        html: [['p',
            [`TBD`],
        ]],
    },
];
return E;
});
